import './styles/app.scss';
import { h, render, Component } from 'preact';

import SuperNav from './components/SuperNav.js';
import Header from './components/Header.js';
import JobOpenings from './components/JobOpenings.js';
import OurStudio from './components/OurStudio.js';
import Footer from './components/Footer.js';

import MetaInformation from './components/MetaInformation.js';
import Provider from 'preact-context-provider';

const branding = {
	headerFont: '"Oswald", sans-serif',
	bodyFont: '"Roboto", sans-serif',
	logoSmall: 'https://webcdn.hirezstudios.com/studios/EvilMojoIcon.png',
	logoLarge: 'https://webcdn.hirezstudios.com/studios/EvilMojoFooterLogo.png',
	gameURL: 'https://www.paladins.com',
	studioPhoto: 'https://webcdn.hirezstudios.com/studios/EvilMojoTeamPic.jpg',
	jobsUrl: 'https://www.hirezstudios.com/careers/',
	jobsBackground: 'https://webcdn.hirezstudios.com/studios/EvilMojoJobs.jpg',
	headerBackground: 'https://webcdn.hirezstudios.com/studios/EvilMojoHeader.jpg'
};

const colors = {
	primary: '#4A3D57',
	accent: '#99FF00',
	link: '#FFFFFF',
	hoverLink: '#99FF00',
	copy: '#000000'
};

const copy = {
	longName: 'Evil Mojo Games',
	shortName: 'Evil Mojo',
	gameName: 'Paladins',
	tagLine: 'Become A Champion',
	aboutCopy: 'Evil Mojo Games enchants players with living, free-to-play worlds (and also magic). Their award-winning, critically acclaimed game Paladins has attracted more than 30 million players on PC, PlayStation 4, Xbox One and Nintendo Switch. Evil Mojo Games believes the best games are bigger than a box can contain; their epic stories and endlessly rewarding gameplay are brought to life through constant updates. Working hand-in-hand with its strong community, Evil Mojo Games will one day rule the world.',
	footerCopy: ''
};

const meta = {
	favicon: 'https://webcdn.hirezstudios.com/studios/EvilMojoIcon.png',
	description: 'Evil Mojo Games enchants players with living, free-to-play worlds (and also magic). Their award-winning, critically acclaimed game Paladins has attracted more than 30 million players on PC, PlayStation 4, Xbox One and Nintendo Switch.',
	url: 'https://www.evilmojogames.com',
	image: 'https://webcdn.hirezstudios.com/studios/evil-mojo-meta.jpg'
};

class App extends Component {

	constructor(props) {
		super(props);
		this.state = {
			language: null
		};
	}

	render() {
		return (
			<div className="page-titan-forge">
				<MetaInformation
					description={meta.description}
					favicon={meta.favicon}
					image={meta.image}
					title={copy.longName}
					url={meta.url}
				/>
				<SuperNav />
				<Header />
				<JobOpenings />
				<OurStudio />
				<Footer />
			</div>
		);
	}
}

if (typeof window !== 'undefined') {
	render(
		<Provider colors={colors} branding={branding} copy={copy}>
			<App />
		</Provider>,
		document.body
	);
}


// WEBPACK FOOTER //
// ./index.js